import { Paper, Box, Typography, Stack, LinearProgress } from '@mui/material';
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from 'recharts';
import { tokens } from '../../../theme/theme';

function bandColor(v) {
  if (v >= 80) return tokens.severity.low;
  if (v >= 60) return tokens.severity.medium;
  return tokens.severity.critical;
}

export default function SecurityScoreGauge({ score }) {
  if (score == null || score.score == null) return null;
  const data = [{ name: 'score', value: score.score, fill: bandColor(score.score) }];

  return (
    <Paper sx={{ p: 2.4, height: '100%' }}>
      <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
        Overall Security Score
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ width: 130, height: 130, position: 'relative', flexShrink: 0 }}>
          <ResponsiveContainer>
            <RadialBarChart
              innerRadius="72%" outerRadius="100%" data={data} startAngle={90} endAngle={-270}
            >
              <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
              <RadialBar dataKey="value" cornerRadius={8} background={{ fill: tokens.bg.elevated }} />
            </RadialBarChart>
          </ResponsiveContainer>
          <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <Typography variant="h4" sx={{ fontSize: '1.8rem', color: tokens.text.primary }}>{score.score}</Typography>
            <Typography variant="caption" sx={{ color: tokens.text.muted }}>/ 100</Typography>
          </Box>
        </Box>
        <Stack spacing={1} sx={{ flex: 1 }}>
          {Object.entries(score.breakdown).map(([key, val]) => (
            <Box key={key}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                <Typography variant="caption" sx={{ color: tokens.text.secondary, textTransform: 'capitalize' }}>{key}</Typography>
                <Typography variant="caption" sx={{ color: tokens.text.muted, fontFamily: '"JetBrains Mono", monospace' }}>{val}</Typography>
              </Box>
              <LinearProgress
                variant="determinate" value={val}
                sx={{
                  height: 5, borderRadius: 4, backgroundColor: tokens.bg.elevated,
                  '& .MuiLinearProgress-bar': { backgroundColor: bandColor(val), borderRadius: 4 }
                }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </Paper>
  );
}
